export default class FollowModel {
    public profile_ids: string[] = [];
}